import React from "react";

const industriesList = [
  { id: "health-care", name: "Health Care & Public Health" },
  { id: "government", name: "Government & Public Services" },
  { id: "fintech", name: "Financial Services & Fintech" },
  { id: "telecom", name: "Telecom & Customer Support" },
  { id: "education", name: "Education & EdTech" },
  { id: "ngo", name: "NGOs & Humanitarian Services" },
  { id: "media", name: "Media, Content & Entertainment" },
  { id: "travel", name: "Travel, Hospitality & Transportation" },
  { id: "hr", name: "HR, Workforce & Training" }
];

const JumpToNav = ({ activeId, onSelect }) => {
  return (
    <section className="w-full bg-[#F4F7F5] border-y border-[#E2E8E4] py-8 sm:py-10">
      <div className="max-w-8xl mx-auto px-8 sm:px-12 md:px-16 lg:px-24 xl:px-32">
        <div className="flex flex-col gap-4">
          <div className="text-[#0D3429] font-bold text-sm sm:text-base font-['Axiforma',sans-serif]">
            Jump To :
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-3.5 gap-x-8">
            {industriesList.map((item) => {
              const isCurrent = activeId === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => onSelect(item.id)}
                  className={`text-left text-xs sm:text-sm font-semibold transition-all duration-200 underline underline-offset-4 ${isCurrent
                      ? "text-[#1E6551] font-bold decoration-[#1E6551] decoration-2"
                      : "text-[#0D3429] hover:text-[#1E6551] decoration-gray-400 hover:decoration-[#1E6551]"
                    }`}
                >
                  {item.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JumpToNav;
